import { Box, Tooltip } from "@mui/material";

export interface AdvisorFeesMissingBadgeProps {
  /** Standard services still without a quote (e.g. ["Valuation", "Legal"]). */
  missing: string[];
  /** Open the deal's Advisor Fees tab. */
  onOpen?: () => void;
}

/** Compact pipeline chip: a deal in closing is missing advisor fee quotes. */
export function AdvisorFeesMissingBadge({
  missing,
  onOpen,
}: AdvisorFeesMissingBadgeProps) {
  const open = (e: React.SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onOpen?.();
  };

  return (
    <Tooltip
      title={`Advisor fee quotes missing: ${missing.join(", ")}`}
      placement="right"
    >
      <Box
        component="span"
        role={onOpen ? "button" : undefined}
        tabIndex={onOpen ? 0 : undefined}
        aria-label={`Advisor fee quotes missing: ${missing.join(", ")}`}
        onClick={onOpen ? open : undefined}
        onKeyDown={
          onOpen
            ? (e) => {
                if (e.key === "Enter" || e.key === " ") open(e);
              }
            : undefined
        }
        sx={{
          color: "#fff",
          backgroundColor: "warning.main",
          fontWeight: 700,
          fontSize: 10,
          lineHeight: 1.2,
          px: 0.75,
          py: 0.25,
          borderRadius: "999px",
          display: "inline-block",
          flexShrink: 0,
          cursor: onOpen ? "pointer" : "default",
        }}
      >
        Fees
      </Box>
    </Tooltip>
  );
}
